/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React, { useEffect, useState } from 'react'
import Modal from '../Modal'

interface ConfirmationModalProps {
  title: string
  message: string | React.ReactNode
  cancelText?: string
  confirmText?: string
  onConfirm: () => void
  onCancel?: () => void
  loading?: boolean
  variant?: 'info' | 'warning' | 'danger'
}

export function ConfirmationModal({
  title,
  message,
  cancelText = 'No',
  confirmText = 'Yes',
  onConfirm,
  onCancel,
  loading = false,
  variant = 'info'
}: ConfirmationModalProps) {
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    setIsOpen(true)
  }, [])

  const handleConfirm = () => {
    onConfirm()
    handleClose()
  }

  const handleCancel = () => {
    if (onCancel) {
      onCancel()
    }
    handleClose()
  }

  const handleClose = () => {
    setIsOpen(false)
  }

  return (
    <Modal
      show={isOpen}
      handleClose={handleCancel}
      title={title}
      size="md"
      className="confirmation-modal theme-sandman"
    >
      <Modal.Body>
        <div style={{ wordBreak: 'break-word' }}>{message}</div>
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn btn-link" onClick={handleCancel} disabled={loading} data-action="cancel">
          {cancelText}
        </button>
        <button
          type="button"
          className={`btn btn-${variant === 'danger' ? 'danger' : 'primary'} text-capitalize`}
          onClick={handleConfirm}
          disabled={loading}
          data-action="ok"
        >
          {loading ? 'Loading...' : confirmText}
        </button>
      </Modal.Footer>
    </Modal>
  )
}

export default ConfirmationModal
